import { render, staticRenderFns } from "./settings.vue?vue&type=template&id=2608d32a&scoped=true&"
import script from "./settings.vue?vue&type=script&lang=js&"
export * from "./settings.vue?vue&type=script&lang=js&"
import style0 from "./settings.vue?vue&type=style&index=0&id=2608d32a&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2608d32a",
  null
  
)

component.options.__file = "settings.vue"
export default component.exports